import React from 'react';
import useOrganizationGroups from '../../../../../hooks/api/useOrganizationGroups';
import { OrganizationTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';
import EditGroupForm from './EditGroupForm';
import { RouteProp } from '@react-navigation/native';

export type EditGroupScreenOwnProps = {};

export type EditGroupScreenProps = EditGroupScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'edit-group'>;
};

const EditGroupScreen: React.FC<EditGroupScreenProps> = (props) => {
    const goBack = useGoBack();
    const { isUpdatingGroup, updateGroup, group, isLoadingGroup } = useOrganizationGroups({
        onUpdateGroupSuccess: goBack,
        groupId: props.route.params.groupId,
    });
    const isDisabledByParent = useIsDisabledByParent(isUpdatingGroup);
    return (
        <AnimateLoadedContent isLoading={isLoadingGroup || !group}>
            {() => (
                <EditGroupForm
                    group={group!}
                    onUpdate={(group) => updateGroup({ groupId: props.route.params.groupId, group })}
                    isDisabled={isDisabledByParent}
                    onCancel={goBack}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditGroupScreen);
